var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "mail_svg__icon mail_svg__icon-tabler mail_svg__icon-tabler-mail",
  width: 24,
  height: 24,
  strokeWidth: 2,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m3 7 9 6 9-6"
})));
export default SvgMail;